<template>
  <v-dialog
    :value="value"
    @input="close"
    max-width="1200"
    transition="dialog-bottom-transition">
    <v-card class="rounded-xl">
      <form @submit.prevent="save">
        <v-card-title>
          <v-icon left>{{ dialogHeader.icon }}</v-icon> {{ dialogHeader.title }}
          <v-spacer />
          <v-btn icon @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />

        <!-- <v-text-field v-model="gate.name" label="Név" :error-messages="errors.name" filled
          v-mask="$config.inputMasks.name" /> -->

        <v-card-text>
          <v-row dense bordered>
            <v-col cols="12" md="6">
              <v-card flat>
                <v-card-title>Alapadatok</v-card-title>
                <v-card-text>
                  <gate-form :gate="gate" :errors="errors" />
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card flat>
                <v-card-title>Lokáció</v-card-title>
                <v-card-text>
                  <location-form v-model="location" :errors="errors" />
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card flat>
                <v-card-title>Olvasó</v-card-title>
                <v-card-text>
                  <v-select
                    :items="readers"
                    item-value="element_id"
                    item-text="name"
                    v-model="gate.reader"
                    label="Olvasó kiválasztása"
                    filled
                    return-object
                    :error-messages="Object.entries(errors.reader ?? []).length ? 'Hiba' : ''"
                  />
                  <reader-form
                    v-if="gate.reader.element_id !== undefined"
                    :reader="gate.reader"
                    :number="controller.readers?.length"
                    :errors="errors.reader"
                  />
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card flat>
                <v-card-title>Relé</v-card-title>
                <v-card-text>
                  <v-select
                    :items="relays"
                    item-value="element_id"
                    item-text="name"
                    v-model="gate.relay"
                    label="Relé kiválasztása"
                    filled
                    return-object
                    :error-messages="Object.entries(errors.relay ?? []).length ? 'Hiba' : ''"
                  />
                  <relay-form
                    v-if="gate.relay.element_id !== undefined"
                    :relay="gate.relay"
                    :number="controller.relays?.length"
                    :errors="errors.relay"
                  />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <!-- {{ relay }} -->

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            class="ma-4"
            depressed
            @click="save"
            :loading="loading"
            flat>
            <v-icon left>mdi-check</v-icon>
            Mentés
          </v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { useVModels } from '@vueuse/core';

import GateForm from '@/components/forms/Gate.vue';
import LocationForm from '@/components/forms/Location.vue';
import ReaderForm from '@/components/forms/Reader.vue';
import RelayForm from '@/components/forms/Relay.vue';

export default {
  components: {
    GateForm,
    LocationForm,
    ReaderForm,
    RelayForm,
  },

  props: {
    value: {
      type: Boolean,
    },

    gate: {
      type: Object,
      default: () => ({}),
    },

    gateType: {
      type: String,
      required: true,
      validator(value) {
        return ['barrier', 'door', 'turnstile'].includes(value);
      },
    },

    controller: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(props, { emit }) {
    const { gate } = useVModels(props, emit);
  },

  data() {
    return {
      // step: 1,
      // dialog: false,
      loading: false,
      _location: {},
      errors: {
        reader: {},
        relay: {},
      },
      // gate: {
      //   relay: {},
      // },
      // errors: {},
    };
  },

  // watch: {
  //   value: {
  //     immediate: true,

  //     handler(value) {
  //       this.dialog = value;
  //     },
  //   },
  // },

  methods: {
    yCoordInput(yCoord) {
      console.log('yCoordInput', yCoord);
      this.gate.y_coord = yCoord;
    },

    close() {
      this.dialog = false;
      this.$emit('input', false);
      this.$emit('close');
    },

    async save() {
      try {
        // this.loading = true;
        setTimeout(() => {
          this.loading = false;
        }, 10000);

        this.errors = {
          reader: {},
          relay: {},
        };

        const response = await this.$http.post('controllers/save-gate', {
          gate_type: this.gateType,
          controller_id: this.controller.element_id,
          ...this.gate,
        });
        if (response.status === 'OK' && Object.entries(response.errors).length === 0) {
          this.$emit('save', response.gate);
          this.close();
          // this.gate = {};
          this.$dialog.notify.success('Sikeres mentés!');
        } else {
          console.log(response);
          this.errors = response.errors;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {
    dialogHeader() {
      switch (this.gateType) {
        case 'barrier':
          return {
            title: this.gate?.element_id ? 'Sorompó szerkesztése' : 'Sorompó létrehozása',
            icon: 'mdi-boom-gate-up',
          };
        case 'door':
          return {
            title: this.gate?.element_id ? 'Ajtó szerkesztése' : 'Ajtó létrehozása',
            icon: 'mdi-door',
          };
        case 'turnstile':
          return {
            title: this.gate?.element_id ? 'Forgóvilla szerkesztése' : 'Forgóvilla létrehozása',
            icon: 'mdi-turnstile',
          };
        default:
          return 'Kapu létrehozása';
      }
    },

    location: {
      get() {
        const ret = {
          buildingId: this.gate.building_id ?? null,
          buildingLevelId: this.gate.building_level_id ?? null,
          xCoord: this.gate.x_coord ?? null,
          yCoord: this.gate.y_coord ?? null,
        };
        return ret;
      },
      set(value) {
        this.gate.building_id = value.buildingId;
        this.gate.building_level_id = value.buildingLevelId;
        this.gate.x_coord = value.xCoord;
        this.gate.y_coord = value.yCoord;
      },
    },
  },

  asyncComputed: {
    buildings: {
      async get() {
        const response = await this.$http.get(`buildings/list`);
        return response.buildings;
      },
    },

    buildingLevels: {
      async get() {
        const response = await this.$http.get(`building-levels/list`);
        return response.building_levels;
      },
    },

    relays: {
      async get() {
        const response = await this.$http.post(`relays/list`, {
          controller_id: this.controller.element_id,
        });
        return [{ name: 'Új relé létrehozása', element_id: 0 }, ...response.relays];
      },
    },

    readers: {
      async get() {
        const response = await this.$http.post(`readers/list`, {
          controller_id: this.controller.element_id,
        });
        return [{ name: 'Új olvasó létrehozása', element_id: 0 }, ...response.readers];
      },
    },
  },
};
</script>
